import React from "react";

export const ToolsCard = ({ icon, name, onSelect, checked }) => {
  return (
    <div className="flex justify-between items-center py-4 bg-white rounded-lg p-2 my-2 dark:bg-transparent border dark:border-[#5B5B5B]">
      <div className="flex items-center space-x-2">
        <img src={icon} alt={name} />
        <p>{name}</p>
      </div>
      <input
        type="checkbox"
        className="custom-checkbox"
        onChange={onSelect}
        checked={checked}
      />
    </div>
  );
};
